import {
  DATA_REQUEST_BEGIN,
  DATA_REQUEST_LOADING,
  DATA_REQUEST_COMPLETED,
  DATA_REQUEST_CANCELLED,
  DATA_REQUEST_FAILURE,
} from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';

export const ListingsBenchmarkGeneralActionTypes = {
  GET_DATA_REQUEST_BEGIN: DATA_REQUEST_BEGIN(LISTINGS_BENCHMARK_REDUCER_NAME),
  SET_DATA_REQUEST_LOADING: DATA_REQUEST_LOADING(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  ),
  GET_DATA_REQUEST_COMPLETE: DATA_REQUEST_COMPLETED(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  ),
  GET_DATA_REQUEST_CANCELLED: DATA_REQUEST_CANCELLED(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  ),
  GET_DATA_REQUEST_ERROR: DATA_REQUEST_FAILURE(LISTINGS_BENCHMARK_REDUCER_NAME),
};
